module.exports = __webpack_public_path__ + "static/media/meet-modi.9707f37e.png";